import Android from "../img/review/ANDROID.png";
import ios from "../img/review/iOS.png";
import app from "../img/review/APP.png";
import web from "../img/review/WEB.png";
// import html5 from "../img/review/html5.png";

import preview1 from "../img/portfolio/IMG-15.png";
import preview2 from "../img/portfolio/IMG-1.png";
import preview3 from "../img/portfolio/IMG-2.png";
import preview4 from "../img/portfolio/IMG-5.png";
import preview5 from "../img/portfolio/IMG-4.png";
import preview6 from "../img/portfolio/IMG-3.png";
import preview7 from "../img/portfolio/IMG-6.png";
import preview8 from "../img/portfolio/IMG-7.png";
import preview9 from "../img/portfolio/IMG-8.png";
import preview10 from "../img/portfolio/IMG-11.png";
import preview11 from "../img/portfolio/IMG-10.png";
import preview12 from "../img/portfolio/IMG-9.png";
import preview13 from "../img/portfolio/IMG-12.png";
import preview14 from "../img/portfolio/IMG-13.png";
import preview15 from "../img/portfolio/IMG-14.png";
import preview16 from "../img/portfolio/Freepi.jpg";
import preview17 from "../img/portfolio/MiraeTalk.jpg";
import oleumdal from "../img/portfolio/oleumdal.jpg";

export const PortfolioData = [
  {
    id: 1,
    image: preview1,
    types: [app, web],
    title: "치과용 솔루션 맞춤 웹",
    text: "웹 리뉴얼 및 치과 진단 솔루션의 웹 기반 SaaS 전환",
    link: "https://blog.naver.com/datafive/223901163588",
  },
  {
    id: 2,
    image: preview2,
    types: [web],
    title: "Modbus기반 대시보드",
    text: "실시간 IoT 설비 감시 모니터링 웹개발 센서 데이터 대시보드 시각화",
    link: "https://blog.naver.com/datafive/223942657017",
  },
  {
    id: 3,
    image: preview3,
    types: [Android, app],
    title: "IoT 원격 팬제어 앱",
    text: "Wifi MQTT 실시간 통신 Smart Config를 사용하여 IoT 기기 설정",
    link: "https://blog.naver.com/datafive/223934598813",
  },
  {
    id: 4,
    image: preview4,
    types: [Android, app],
    title: "IoT 연동 커피 추출 앱",
    text: "스마트 기기와 연동해 편리하게 커피를 추출하는 앱",
    link: "https://blog.naver.com/datafive/223902030272",
  },
  {
    id: 5,
    image: preview5,
    types: [ios, Android, app],
    title: "소비 관리용 할인 정보 앱",
    text: "할인 정보 제공과 소비 기록을 함께 관리하는 실속형 앱",
    link: "https://blog.naver.com/datafive/223960880729",
  },
  {
    id: 6,
    image: preview6,
    types: [ios, Android, app],
    title: "IoT연동허브블록제어앱",
    text: "폐블록에 IoT 기술을 접목한 교육용 제어 앱 개발",
    link: "https://blog.naver.com/datafive/223573287719",
  },
  {
    id: 7,
    image: preview7,
    types: [ios, Android, app],
    title: "GPS 기반 장소저장 앱",
    text: "가보고 싶은 곳이나 다녀온 장소를 기록하는 위치 저장 앱",
    link: "https://blog.naver.com/datafive/223582595139",
  },
  {
    id: 8,
    image: preview8,
    types: [ios, Android, app],
    title: "GPS 기반 원격주문 앱",
    text: "카페 원격 주문, 빠른 픽업, 멤버십 관리까지 모두 지원",
    link: "https://blog.naver.com/datafive/223573273675",
  },
  {
    id: 9,
    image: preview9,
    types: [ios, Android, app],
    title: "비대면 플라워 배송 앱",
    text: "손쉬운 주문과 배달 현황 확인을 앱에서 손쉽게",
    link: "https://blog.naver.com/datafive/223588291261",
  },
  {
    id: 10,
    image: preview12,
    types: [app, web],
    title: "자동차 매물조회 앱",
    text: "원하는 차량을 빠르게 찾아주는 자동차 매물 검색 앱",
    link: "https://blog.naver.com/datafive/223573268066",
  },
  {
    id: 11,
    image: preview11,
    types: [ios, Android, app],
    title: "실시간 물물교환 중개앱",
    text: "사용자 간 물품을 즉시 교환할 수 있도록 중개해주는 플랫폼",
    link: "https://blog.naver.com/datafive/223588425925",
  },
  {
    id: 12,
    image: preview10,
    types: [ios, Android, app],
    title: "무선 네트워크 설정 앱",
    text: "간편하게 Wi-Fi 설정과 공유기 관리를 지원하는 앱",
    link: "https://blog.naver.com/datafive/223706866432",
  },
  {
    id: 13,
    image: preview13,
    types: [Android, app, web],
    title: "학원 수업 관리 앱",
    text: "학원의 수업 일정과 학생 관리를 간편하게 지원하는 앱",
    link: "https://blog.naver.com/datafive/223712926457",
  },
  {
    id: 14,
    image: preview14,
    types: [ios, Android, app, web],
    title: "실시간 재고관리 앱",
    text: "입출고 관리를 통해 재고 반영을 실시간으로 정확하게 돕는 앱",
    link: "https://blog.naver.com/datafive/224059003842",
  },
  {
    id: 15,
    image: preview15,
    types: [Android, app],
    title: "원격 주문 테이블 오더 앱",
    text: "스마트한 테이블 주문과 결제 기능을 제공하는 앱",
    link: "https://blog.naver.com/datafive/223593139262",
  },
  {
    id: 16,
    image: preview16,
    types: [web],
    title: "환자 모니터링 시스템",
    text: "욕창 환자 상태 모니터링(웹기반)",
    link: "https://blog.naver.com/datafive/224066027071",
  },
  {
    id: 17,
    image: preview17,
    types: [Android, app],
    title: "정보성 알림 발송 앱",
    text: "증시 뉴스 및 인사이트를 관리자 페이지에서 발송",
    link: "https://blog.naver.com/datafive/224066028788",
  },
  {
    id: 18,
    image: oleumdal,
    types: [ios, Android, app],
    title: "투자 기록 관리 앱",
    text: "감정과 투자 이유를 기록하면 투자 성향을 분석해 리포트를 제공하는 서비스",
    link: "https://blog.naver.com/datafive/224209700082",
  },
  //  {
  //   id: 1,
  //   image: preview,
  //   types: [],
  //   title: "",
  //   text: "",
  //   link: "",
  // },
];
